import { gql } from "@apollo/client";

export default gql`
  query getGoalParticipantsQuery($artifactId: Int!) {
    basicGoal(artifactId: $artifactId) {
      id
      canRead {
        permission
      }
      canUpdate {
        permission
      }
      goalArtifact {
        id
        title
        keyResults {
          edges {
            node {
              id
              title
              assignee {
                id
              }
            }
          }
        }
      }
      owners {
        totalCount
        edges {
          node {
            id
            avatar
            name
          }
        }
      }
      contributors {
        edges {
          node {
            id
            avatar
            name
          }
        }
      }
    }
  }
`;
